import { useAuth } from '../auth/AuthContext'
import { API_URL } from '../config/apiBase'

// Create a wrapper for fetch that automatically handles token refresh
export async function apiCall(
  url: string, 
  options: RequestInit = {}, 
  refreshToken?: () => Promise<{ ok: boolean; error?: string }>
): Promise<Response> {
  const token = localStorage.getItem('auth_token')
  
  const requestOptions: RequestInit = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  }

  let response = await fetch(`${API_URL}${url}`, requestOptions)

  // If we get a 401 and have a refresh token function, try to refresh
  if (response.status === 401 && refreshToken) {
    const refreshResult = await refreshToken()
    if (refreshResult.ok) {
      // Retry the request with the new token
      const newToken = localStorage.getItem('auth_token')
      const retryOptions: RequestInit = {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...(newToken && { Authorization: `Bearer ${newToken}` }),
          ...options.headers,
        },
      }
      response = await fetch(`${API_URL}${url}`, retryOptions)
    }
  }

  return response
}

// Hook to get an API call function with automatic token refresh
export function useApiCall() {
  const { refreshToken } = useAuth()
  
  return (url: string, options: RequestInit = {}) => 
    apiCall(url, options, refreshToken)
}
